import { Component, Input } from '@angular/core';

@Component({
	selector: 'project-team-members',
	template: require('./project.team.members.component.html'),
})
export class ProjectTeamMembersComponent {

	@Input() parentCtrl: any = null;

	constructor(
	) { }
}
